export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v2-detail-75bd91b12cc80438a36202e919da1c60.png";